// dependencies
import React from 'react';
import './../Terms/Terms.css';
import './About.css';
import { Link } from 'react-router-dom';
import {
   FaFacebook,
   FaTwitter,
   FaGithub,
   FaLinkedin,
   FaRegGrinHearts,
   FaCode,
   FaRegHeart,
} from 'react-icons/fa';

const About = () => {
   return (
      <div className="content common-blue">
         <div className="tos-container">
            <h2 className="text" style={{ textAlign: 'center' }}>
               {' '}
               About Us{' '}
            </h2>
            <hr />
            <p style={{ textAlign: 'justify' }}>
               Hi there! <br /> Glad to know that you are interested to know
               about our application. We are all aware that BTEB has not
               developed any automatic result searching system for diploma
               students. That's why most of the students cannot get their
               results on their own after the results of final exams are
               published. Our main goal is to make the life of all these
               students a little easier so that they can quickly get their
               results in a few seconds by entering their roll number and
               semester. We think this will save your time and reduce dependence
               on others. Do you feel that we have been able to succeed in our
               goal? If yes, Our efforts are worthwhile. <FaRegGrinHearts />
               <br />
               If you have any queries or suggestions about our application,
               please feel free to {' '}
               <Link
                  style={{
                     color: '#1f8fe5',
                     textDecoration: 'underline',
                     fontSize: '16px',
                  }}
                  to="/contact"
               >
                  let us know
               </Link>
               . We will definitely try to give importance to your opinion.{' '}
               <FaRegHeart />
            </p>

            <div className="developer">
               <h3 style={{ marginTop: '20px' }}> Developer </h3>
               <hr style={{ marginBottom: '5px', marginLeft: '0' }} />
               <h4 style={{ letterSpacing: '0.5px' }}>MD. Mehedi Islam Ripon</h4>
               {/* <p> Aptouch Polytechnic Institute, Dinajpur </p> */}
               <p> Dhaka International University </p>
               {/* <p> Department: Computer </p> */}
               <p> Department of CSE </p>
               {/* <p> Semester: 8th </p> */}
               <p> Alumni: Aptouch Polytechnic Institute </p>
               <p>
                  {' '}
                  <span>
                     {' '}
                     <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.facebook.com/mehediislamripon"
                     >
                        <FaFacebook />
                     </a>{' '}
                  </span>{' '}
                  <span>
                     {' '}
                     <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://github.com/MehedilslamRipon"
                     >
                        <FaGithub />
                     </a>{' '}
                  </span>{' '}
                  <span>
                     {' '}
                     <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.codegrepper.com/profile/mehedi-islam-ripon"
                     >
                        <FaCode />
                     </a>{' '}
                  </span>{' '}
                  <span>
                     {' '}
                     <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://twitter.com/MehediIslam404"
                     >
                        <FaTwitter />
                     </a>{' '}
                  </span>{' '}
                  <span>
                     {' '}
                     <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.linkedin.com/in/mehedi-islam-ripon"
                     >
                        <FaLinkedin />
                     </a>{' '}
                  </span>{' '}
               </p>
            </div>
         </div>
      </div>
   );
};

export default About;
